import {
  LOGIN,
  LOGOUT,
  RESTORE_TOKEN,
  GET_ME,
  SKIP_ONBOARDING,
  GET_USER_ACCOUNTS,
  GET_CONNECTIONS,
  SET_THEME,
} from './types';
import { resolved } from 'store/createAction';
import * as userSvc from 'services/users';
import cookie from 'utils/cookie';

export const login = (payload) => {
  cookie.set('token', payload.token, {
    maxAge: 30 * 24 * 60 * 60,
    path: '/',
  });
  cookie.set('device_id', payload.device_id, {
    maxAge: 2147483647,
    path: '/',
  });
  return {
    type: LOGIN,
    payload: payload,
  };
};

export const logout = () => {
  try {
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    cookie.remove('token', { path: '/' });
    cookie.remove('hide_upgrade_banner', { path: '/' });
    cookie.remove('skip_sender_profile');
  } catch (e) {
    console.log(e);
  }
  return {
    type: LOGOUT,
  };
};

export const restoreToken = (token) => ({
  type: RESTORE_TOKEN,
  payload: { token },
});

export const restoreSession = (user) => ({
  type: resolved(GET_ME),
  payload: user,
});

export const getMe = () => ({
  type: GET_ME,
  payload: {
    promise: userSvc.getMe(),
  },
});

export const getAccounts = (userId) => ({
  type: GET_USER_ACCOUNTS,
  payload: {
    promise: userSvc.getUserAccounts(userId),
  },
});

export const skipOnboarding = () => {
  return (dispatch, getState) => {
    const { user } = getState().user;
    const account = getState().settings.account;
    return dispatch({
      type: SKIP_ONBOARDING,
      payload: {
        promise: userSvc.skipOnboarding(user.user_hash, account.account_id),
      },
    });
  };
};

export const getConnections = (userId) => ({
  type: GET_CONNECTIONS,
  payload: {
    promise: userSvc.getUserPhoneNumbers(userId),
  },
});

export const setTheme = (isDarkMode) => {
  cookie.set('isDarkMode', isDarkMode ? '1' : '0', {
    maxAge: 2147483647,
    path: '/',
  });
  return {
    type: SET_THEME,
    payload: isDarkMode,
  };
};
